module.exports = __webpack_public_path__ + "media/images/end-60-8347b81c9e925cabb87238148e019270.png";